<template>
  <div>
    <div v-if="!isLoading" class="row">
      <div v-for="(details, category)  in categories" :key="category" class="col-xl-4">
        <div class="block block-rounded bg-gd-primary">
          <div class="block-content">
            <p v-text="category" class="text-white text-uppercase font-size-md font-w700 text-center mt-2 mb-4"></p>
            <div class="block block-rounded bg-black-10 mb-2">
              <div class="block-content block-content-sm block-content-full d-flex align-items-center justify-content-between">
                <div class="mr-3">
                  <p v-text="details.percentage" class="text-white font-size-h3 font-w300 mb-0"></p>
                  <p class="text-white-75 mb-0">
                    {{$t('accountProfile.categoryDetails.percentage')}}
                  </p>
                </div>
                <div class="item">
                  <i class="fa fa-2x fa-percentage text-primary-lighter"></i>
                </div>
              </div>
            </div>
            <div class="block block-rounded bg-black-10 mb-2">
              <div class="block-content block-content-sm block-content-full d-flex align-items-center justify-content-between">
                <div class="mr-3">
                  <p v-text="details.volume" class="text-white font-size-h3 font-w300 mb-0"></p>
                  <p class="text-white-75 mb-0">{{$t('accountProfile.categoryDetails.volume')}}</p>
                </div>
                <div class="item">
                  <i class="fa fa-2x fa-exchange-alt text-primary-lighter"></i>
                </div>
              </div>
            </div>
            <div class="block block-rounded bg-black-10 mb-3">
              <div class="block-content block-content-sm block-content-full d-flex align-items-center justify-content-between">
                <div class="mr-3">
                  <p v-text="details.count" class="text-white font-size-h3 font-w300 mb-0"></p>
                  <p class="text-white-75 mb-0">
                    {{$t('accountProfile.categoryDetails.txCount')}}
                  </p>
                </div>
                <div class="item">
                  <i class="fa fa-2x fa-list-ol text-primary-lighter"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-xl-4">
        <div class="block block-rounded bg-gd-primary block-mode-loading">
          <div class="block-content">
            <p class="text-white text-uppercase font-size-md font-w700 text-center mt-2 mb-4">{{$t('accountProfile.categoryDetails.loading')}}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="block block-rounded bg-gd-primary block-mode-loading">
          <div class="block-content">
            <p class="text-white text-uppercase font-size-md font-w700 text-center mt-2 mb-4">{{$t('accountProfile.categoryDetails.loading')}}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="block block-rounded bg-gd-primary block-mode-loading">
          <div class="block-content">
            <p class="text-white text-uppercase font-size-md font-w700 text-center mt-2 mb-4">{{$t('accountProfile.categoryDetails.loading')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['categories'],
  name: 'CategoryDetails',
  computed: {
    isLoading () {
      return this.$store.state.options.isLoading
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>
